<template>
  <div>
    <div v-show="isAdDisplay">
      <div>
        <h3 class="text-3xl">
          広告コンバージョン定義
        </h3>
        <div class="mt-3">
          広告コンバージョン定義を変更できます。変更後のデータ取得から新設定がレポートに適応されます。過去分の再集計は行われません。
        </div>
      </div>
      <vx-card class="mt-8 relative">
        <vs-button
          type="border"
          class="absolute top-0 right-0 m-2"
          icon="edit"
          @click="onClickEdit"
        />
        <ad-cv-form
          class="my-8 mx-4"
          :ad-sd-cv-type="adSdCvType"
          :ad-sp-cv-type="adSpCvType"
          :ad-sb-cv-type="adSbCvType"
          read-only
        />
      </vx-card>
      <form-modal
        v-model="showForm"
        title="広告コンバージョン定義"
        submit-button-text="保存"
        fullscreen
        @click:submit="onClickSubmit"
      >
        <template #content>
          <ad-cv-form
            v-model:ad-sd-cv-type="adSdCvType"
            v-model:ad-sp-cv-type="adSpCvType"
            v-model:ad-sb-cv-type="adSbCvType"
            class="mt-8 mb-12"
          />
        </template>
      </form-modal>
    </div>
    <div>
      <h3 class="text-3xl mt-10">
        スライドレポートの自動送付
      </h3>
      <div class="mt-3">
        直近30日間の売上が3000万を超えるアカウントが対象になります。
      </div>
      <switch-field
        v-model="innerMonthlyReportAllowed"
        class="mt-8"
        name="マンスリーレポート"
        label="マンスリーレポート（毎月3日、前月数値）"
      />
      <switch-field
        v-model="innerWeeklyReportAllowed"
        class="mt-8"
        name="ウィークリーレポート"
        label="ウィークリーレポート（毎週火曜日、今月数値）"
      />
    </div>
    <div v-show="isAdDisplay && isBudgetAlertDisplay">
      <h3 class="text-3xl mt-10">
        アラート
      </h3>
      <switch-field
        v-model="innerIsBudgetAlert"
        class="mt-8"
        name="日予算到達"
        label="スポンサー広告の日予算到達"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AdCvForm from '@/components/forms/AdCvForm'
import SwitchField from '@/components/fields/SwitchField'
import FormModal from '@/components/modals/FormModal'
import { debounce } from '@/utils'

export default {
  name: 'AdConversion',
  components: {
    AdCvForm,
    SwitchField,
    FormModal
  },
  data () {
    return {
      isAdDisplay: false,
      isBudgetAlertDisplay: false,
      showForm: false,
      adSdCvType: 3,
      adSpCvType: 1,
      adSbCvType: 1
    }
  },
  computed: {
    ...mapState('account', ['activeAccount']),
    ...mapState('userAccounts', ['userAccounts']),
    innerMonthlyReportAllowed: {
      get () {
        return this.userAccounts.isMonthlyReport
      },
      set (val) {
        this.updateUserAccounts({
          isMonthlyReport: val,
          isWeeklyReport: this.userAccounts.isWeeklyReport,
          isBudgetAlert: this.userAccounts.isBudgetAlert
        })
      }
    },
    innerWeeklyReportAllowed: {
      get () {
        return this.userAccounts.isWeeklyReport
      },
      set (val) {
        this.updateUserAccounts({
          isMonthlyReport: this.userAccounts.isMonthlyReport,
          isWeeklyReport: val,
          isBudgetAlert: this.userAccounts.isBudgetAlert
        })
      }
    },
    innerIsBudgetAlert: {
      get () {
        return this.userAccounts.isBudgetAlert
      },
      set (val) {
        this.updateUserAccounts({
          isMonthlyReport: this.userAccounts.isMonthlyReport,
          isWeeklyReport: this.userAccounts.isWeeklyReport,
          isBudgetAlert: val
        })
      }
    }
  },
  watch: {
    activeAccount: {
      immediate: true,
      handler (val) {
        if (val) {
          this.isAdDisplay = val.adApiOauthComplete
          this.isBudgetAlertDisplay = val.isBudgetAlert
          this.adSdCvType = val.adSdCvType
          this.adSpCvType = val.adSpCvType
          this.adSbCvType = val.adSbCvType
        }
      }
    }
  },
  async mounted () {
    await this.getAccount()
    await this.getUserAccounts()
  },
  methods: {
    ...mapActions('account', ['getAccount', 'updateAccount']),
    ...mapActions('userAccounts', ['getUserAccounts', 'updateUserAccounts']),
    onClickEdit () {
      this.showForm = true
    },
    onClickSubmit: debounce(async function () {
      try {
        await this.updateAccount({
          ...this.activeAccount,
          adSdCvType: this.adSdCvType,
          adSpCvType: this.adSpCvType,
          adSbCvType: this.adSbCvType
        })
        this.showForm = false
      } catch (e) {
        console.error(e)
      }
    }, 1000)
  }
}

</script>

<style>
.con-vs-popup.fullscreen .vs-popup {
  max-width: 980px;
  height: auto;
}
</style>
